import ColumnBase from "./ColumnBase";
import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import {htmlEncode, isValidUrl} from "../../other/utils/otherUtils.jsx";

class UrlColumn extends ColumnBase {
  static get $name() {
    return "UrlColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnUrl;
  }

  static get defaults() {
    return {
      editor: {
        type: WIDGET_KEYS.fieldUrl
      },
      htmlEncode: false,
      renderer({ value }) {
        const formattedUrl = value ? (value.startsWith('http://') || value.startsWith('https://')) ? value: ('http://' + value): null;
        return formattedUrl ? `<a
          href="${formattedUrl}"
          data-link="${formattedUrl}"
          onclick="function hi(event){
            window.open(event.href, '_blank');
            return false;
          }; hi(this); return false">${htmlEncode(value)}
        </a>`: null;
      },
      finalizeCellEdit({ value }) {
        return !value || !!isValidUrl(value);
      }
    };
  }
}

ColumnStore.registerColumnType(UrlColumn);